export const PERMISSIONS = {
  ANALYTICS: { VIEW: "analytics.view" },
  CATEGORY: {
    CREATE: "category.create",
    EDIT: "category.edit",
    DELETE: "category.delete",
  },
  PRODUCT: {
    CREATE: "product.create",
    EDIT: "product.edit",
    DELETE: "product.delete",
  },
  SALES_LIST: {
    CREATE: "sales_list.create",
    EDIT: "sales_list.edit",
    DELETE: "sales_list.delete",
  },
  CONTENT: {
    VIEW: "content.view",
    EDIT: "content.edit",
    PUBLISH: "content.publish",
  },
  PROPERTY: {
    CREATE: "property.create",
    EDIT: "property.edit",
    DELETE: "property.delete",
  },
  BACKUP: {
    LIST: "backup.list",
    CREATE: "backup.create",
    DELETE: "backup.delete",
    DOWNLOAD: "backup.download",
  },
  USER_MANAGEMENT: {
    VIEW: "user_management.view",
    CREATE: "user_management.create",
    CHANGE_ROLE: "user_management.change_role",
    CHANGE_GROUPS: "user_management.change_groups",
    DELETE: "user_management.delete",
    CHANGE_PERMISSIONS: "user_management.change_permissions",
    CHANGE_PROFILE: "user_management.change_profile",
  },
  EVENT_FORM: {
    VIEW: "event_form.view",
    MANAGE: "event_form.manage",
  },
} as const;

type NestedValues<T> = T extends object ? NestedValues<T[keyof T]> : T;
export type PermissionCode = NestedValues<typeof PERMISSIONS>;

function flattenPermissions(obj: Record<string, any>): string[] {
  return Object.values(obj).flatMap((value) => {
    if (typeof value === "string") return [value];
    if (value && typeof value === "object") return flattenPermissions(value);
    return [];
  });
}

export const ALL_PERMISSION_CODES = flattenPermissions(
  PERMISSIONS as Record<string, any>,
) as PermissionCode[];
